import { combineReducers } from 'redux';
import legacyUser from 'vn-legacy-user';
import userData from './ducks/User';
import inputValidationsData from './ducks/inputValidations';

const rootReducer = combineReducers({
    legacyUser,
    userData,
    inputValidationsData
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/rootReducer.js